/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnaction2Inputs */

const en_opportunitiescolumnaction2 = /** @type {(inputs: Opportunitiescolumnaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested move`)
};

const de_opportunitiescolumnaction2 = /** @type {(inputs: Opportunitiescolumnaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfohlener Schritt`)
};

/**
* | output |
* | --- |
* | "Suggested move" |
*
* @param {Opportunitiescolumnaction2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnaction2 = /** @type {((inputs?: Opportunitiescolumnaction2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnaction2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnaction2(inputs)
	return de_opportunitiescolumnaction2(inputs)
});
export { opportunitiescolumnaction2 as "opportunitiesColumnAction" }